import * as React from 'react';
import Ad, { AdSize } from './Ad';
import {
  createMinHugeViewportDecorator,
  createMinLargeViewportDecorator,
  createMinXLargeViewportDecorator,
} from 'webapp/viewport';
import { styled } from '@glitz/react';

export function renderAds(
  currentProductIndex: number,
  ads?: NordicNest.Api.AdApiModel[],
  isSmallViewport?: boolean,
  gridVariant?: string,
) {
  if (!ads || ads.length === 0) {
    return null;
  }

  switch (currentProductIndex) {
    case 6:
      return (
        <FirstAd
          key={currentProductIndex}
          size={isSmallViewport ? AdSize.Medium : AdSize.Large}
          {...ads[0]}
          css={gridVariant === 'max3440px' && firstAdHugeDecorator}
        />
      );
    case 14:
      return ads.length > 1 ? (
        <SecondAd
          key={currentProductIndex}
          size={AdSize.Medium}
          {...ads[1]}
          css={gridVariant === 'max3440px' && secondAdHugeDecorator}
        />
      ) : null;
    case 26:
      return ads.length > 2 ? (
        <ThirdAd key={currentProductIndex} size={isSmallViewport ? AdSize.Medium : AdSize.Small} {...ads[2]} />
      ) : null;
    default:
      return null;
  }
}

export function renderAdsLargeViewport(currentProductIndex: number, ads?: NordicNest.Api.AdApiModel[]) {
  if (!ads || ads.length === 0) {
    return null;
  }

  switch (currentProductIndex) {
    case 8:
      return <Ad key={currentProductIndex} size={AdSize.Large} {...ads[0]} />;
    case 23:
      return ads.length > 1 ? <Ad key={currentProductIndex} size={AdSize.Medium} {...ads[1]} /> : null;
    case 43:
      return ads.length > 2 ? <Ad key={currentProductIndex} size={AdSize.Small} {...ads[2]} /> : null;
    default:
      return null;
  }
}

export function renderAdsSmallViewport(currentProductIndex: number, ads?: NordicNest.Api.AdApiModel[]) {
  if (!ads || ads.length === 0) {
    return null;
  }

  switch (currentProductIndex) {
    case 6:
      return <Ad key={currentProductIndex} isSmallViewport size={AdSize.Medium} {...ads[0]} />;
    case 26:
      return ads.length > 1 ? <Ad key={currentProductIndex} isSmallViewport size={AdSize.Medium} {...ads[1]} /> : null;
    case 42:
      return ads.length > 2 ? <Ad key={currentProductIndex} isSmallViewport size={AdSize.Medium} {...ads[2]} /> : null;
    default:
      return null;
  }
}

const FirstAd = styled(
  Ad,
  createMinXLargeViewportDecorator({
    order: 5,
  }),
  createMinLargeViewportDecorator({
    order: 9,
  }),
  { order: 7 },
);

const firstAdHugeDecorator = styled(
  createMinHugeViewportDecorator({
    order: 6,
  }),
);

const secondAdHugeDecorator = styled(
  createMinHugeViewportDecorator({
    order: 20,
  }),
);

const SecondAd = styled(
  Ad,
  createMinLargeViewportDecorator({
    order: 16,
  }),
  { order: 14 },
);

const ThirdAd = styled(
  Ad,
  createMinXLargeViewportDecorator({
    order: 25,
  }),
  createMinLargeViewportDecorator({
    order: 28,
  }),
  { order: 26 },
);
